import React from "react";
import OmronSearchBox from "../components/app/SearchBox/SearchBox";
import ProductFacetComponent from "../components/app/Facets/ProductsFacet";
import AppLayoutWrapper from "./AppLayoutWrapper";
import Header from "../components/app/Header/Header";

const AppLayout = () => {
  return (
    <AppLayoutWrapper>
      <Header />
      <OmronSearchBox />
      <ProductFacetComponent />
    </AppLayoutWrapper>
  );
};

export default AppLayout;
